import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import '@angular/common/locales/global/es-UY';
import '@angular/common/locales/global/pt';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
